'use strict';

const $ = window.jQuery;

module.exports = function () {
    if ( $('.page-form').length <= 0 ) {
        return
    }

    const carousel = new Swiper('.page-form-slider-wrapper', {
        wrapperClass: 'page-form-slider',
        slideClass: 'page-form-slider__item',
        autoplay: {
            delay: 3000,
        },
        slidesPerView: 1,
        pagination: false,
        navigation: {
            prevEl: '.page-form-slider-nav__btn--prev',
            nextEl: '.page-form-slider-nav__btn--next',
        },
    })
}
